module.exports = __webpack_public_path__ + "img/send.b4bcadec.svg";